import React from "react";
import axios from "axios";
import {useToasts} from "react-toast-notifications";
import {useState} from "react";

const DetalleOptionsSimple = ({data})=>{
    const { addToast } = useToasts();
    const [loading, setLoading] = useState(false)
    const addCart = ()=>{
        setLoading(true);
        axios({
            url: '/api/add-cart',
            method: 'POST',
            data: {
                product: {
                    id: data.id_producto,
                    quantity: 1
                }
            }
        })
            .then(d=>{
                setLoading(false);
                addToast(d.data.message, { appearance: 'success', autoDismiss: true });
            })
            .catch(e=>{
                setLoading(false);
                addToast('No se puedo agregar el producto a tu carrito, recarga la pagina e intenta de nuevo', { appearance: 'warning', autoDismiss: false });
            })
    }
    return <>
        { (data?.price?.precio && !data?.disabled) ?
            (<button className="button button-large" onClick={e=>{ addCart() }} disabled={loading}>{ loading ? "Espera un momento..." : "Agregar al carrito" }</button>)
            :
            (<button className="button button-large" disabled={true} >Producto no disponible o Agotado</button>)
        }
    </>


}

export default DetalleOptionsSimple;
